import React from "react";
import { Link } from "react-router-dom";

const SubSubCategory3 = ({data}) => {
    // Dummy data for categories with placeholder images
    const baseImageUrl =
      "https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/";

    const categories = data.get_home_component_details.content.map(
      (item, index) => ({
        id: item.sub_sub_category_auto_id,
        name: item.sub_category_name,
        image: item.subcategory_image_app
          ? `${baseImageUrl}${item.subcategory_image_app}`
          : "https://via.placeholder.com/400", 
      })
    );
    const truncateNameMobile = (name) => {
        return name.length > 20 ? name.substring(0, 20) + "..." : name;
    };

    const truncateNameDesktop = (name) => {
        return name.length > 25 ? name.substring(0, 25) + "..." : name;
    };

    return (
      <div
        className="p-2"
        style={{
          backgroundColor: data.web_background_color,
        }}
      >
        {" "}
        {/* Padding on both sides */}
        <h4
          className={`text-center p-3 ${data.web_title_font}`}
          style={{
            color: data.web_title_color,
          }}
        >
          {data.title}
        </h4>
        {/* Desktop View: 6 Cards per Row, No Gap, Fully Rounded */}
        <div className="items-center justify-center hidden w-full grid-cols-2 gap-3 px-48 overflow-hidden lg:grid">
          {categories.map((category, index) => {
            const isLastOddCard =
              categories.length % 2 !== 0 && index === categories.length - 1;

            return (
              <Link
                key={category.id}
                to="/subsubcatproductlist"
                state={{
                  subsubcategoryName: category.name,
                  sub_sub_cat_id: category.id,
                }}
                className={`flex flex-row-reverse bg-gray-800/10 rounded-lg w-full overflow-hidden no-underline 
                                ${
                                  isLastOddCard
                                    ? "col-span-2 justify-self-center"
                                    : ""
                                }`}
                style={isLastOddCard ? { maxWidth: "calc(50% - 0.75rem)" } : {}}
              >
                {/* Image on the Right */}
                <img
                  src={category.image}
                  alt={category.name}
                  className="object-contain w-1/2 h-48 rounded-r-lg"
                />

                {/* Text on the Left */}
                <div className="flex items-center justify-start w-1/2 p-4">
                  <span
                    className={`text-xl text-black font-bold text-left ${data.web_title_font}`}
                  >
                    {category.name}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
        <div className="grid justify-center grid-cols-1 gap-2 lg:hidden">
          {categories.map((category) => (
            <Link
              key={category.id}
              to="/subsubcatproductlist"
              state={{
                subsubcategoryName: category.name,
                sub_sub_cat_id: category.id,
              }}
              className="flex flex-row-reverse w-full overflow-hidden no-underline rounded-lg bg-gray-800/10"
            >
              {/* Image on the Right */}
              <img
                src={category.image}
                alt={category.name}
                className="object-contain w-1/2 h-48 rounded-r-lg"
              />

              {/* Text on the Left */}
              <div className="flex items-center justify-start w-1/2 p-4">
                <span
                  className={`text-xl text-black font-bold text-left ${data.web_title_font}`}
                >
                  {truncateNameMobile(category.name)}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
};

export default SubSubCategory3; 